module.exports = " <div class=items> <podcast v-for=\"item in list\" :key=item.id v-bind:container-width=containerWidth v-bind:display-player-inline=displayPlayerInline v-bind:drop-to-live=dropToLive v-bind:index=$index v-bind:podcast=item v-bind:smc=smc v-bind:use-m4a=useM4a v-on:pauseothers=onPauseOthers($index) v-ref:players></podcast> <pagination v-bind:page-list=pageList v-bind:category=category></pagination> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/podcast_list.vue
// module id = 310
// module chunks = 0